import { Anchor, Stack } from '@mantine/core';
import { observer } from 'mobx-react-lite';
import * as React from 'react';

import { useRootStore } from 'stores/global/RootStore/context';
import { useLkLayoutStore } from 'stores/local/layout/LkLayoutStore';

import s from './MenuBottomLinks.module.scss';

const MenuBottomLinks: React.FC = () => {
  const { menu } = useLkLayoutStore();
  const {
    generalInformationStrapi: { infoLinks },
  } = useRootStore();

  if (infoLinks.value.length === 0 || !menu.isOpen) {
    return null;
  }

  return (
    <Stack gap="sm">
      {infoLinks.value.map((link) => (
        <Anchor
          key={link.name}
          className={s.link}
          href={link.url}
          download={link.url}
          size="xs"
          underline="always"
          target="_blank"
        >
          {link.name}
        </Anchor>
      ))}
    </Stack>
  );
};

export default observer(MenuBottomLinks);
